import React, { FC } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { selectProcessingEntry } from '../../selectors/oneClickBet';
import Entry from './Entry';
import Preferences from './Preferences';

import styles from './OneClickBet.module.scss';

// ---

type StoreProps = {
  processing: boolean;
};

const OneClickBet: FC<StoreProps> = ({ processing }) => {
  return (
    <>
      <Preferences />
      {processing && (
        <div className={styles.container}
             data-test="oneClickBet-container">
          <Entry />
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  processing: selectProcessingEntry(state) !== null,
});

export default connect(mapStateToProps)(OneClickBet);
